import { FeedService } from '@xq/infrastructure';
import { StreamClient } from 'getstream';

export class UnsubscribeFromFeedUseCase {
  static execute(client: StreamClient) {
    return FeedService.getInstance(client).unsubscribe();
  }
}
